import { FB_PIXEL_RESERVATION, SET_INSTANT_EXPERIENCES, SET_INSTANT_EXPERIENCES_OWNER } from './constants';
import { getInstantExperiences, getInstantExperiencesOwner } from './selectors';
import FBPixel from '../applicationServices/analytics/fbPixel';

export const setInstantExperiences = payload => ({
  type: SET_INSTANT_EXPERIENCES,
  payload,
});

export const setInstantExperiencesOwner = payload => ({
  type: SET_INSTANT_EXPERIENCES_OWNER,
  payload,
});

const pixelReservationEventAction = data => ({
  type: FB_PIXEL_RESERVATION,
  data,
});

export const pixelReservationEvent = data => (dispatch, getState) => {
  const instantExperiences = getInstantExperiences(getState());
  const instantExperiencesOwner = getInstantExperiencesOwner(getState());
  if (!instantExperiences || !FBPixel.fbEventsInitialized) return;

  // track reservation in case shop uses deprecated ig ix and schedule if it's a fbe ig booking
  if (!instantExperiencesOwner) {
    const eventData = {
      reservation_id: data.id,
      reservation_time: data.dateTime,
      reservation_size: 2,
      merchant_id: data.shopId,
    };

    FBPixel.trackReservation('instantExperience', eventData);
    dispatch(pixelReservationEventAction(eventData));
  } else {
    FBPixel.trackSchedule('instantExperience');
  }
};



// WEBPACK FOOTER //
// ./src/app/instantExperiences/actions.js